"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStatusIndex = exports.getStatusDescription = exports.getStatusCodes = exports.getStatusCode = exports.getStatus = exports.getReasonIndex = exports.checkStatusObject = void 0;
var _enums = require("../../enums");
var getStatus = exports.getStatus = function getStatus(statusCode) {
  var status = _enums.statusCodes.find(function (status) {
    return status.code === statusCode;
  });
  return status ? status : null;
};
var getStatusDescription = exports.getStatusDescription = function getStatusDescription(statusCode) {
  var status = _enums.statusCodes.find(function (status) {
    return status.code === statusCode;
  });
  return status ? status.description : "Invalid status code";
};
var getStatusCode = exports.getStatusCode = function getStatusCode(statusDescription) {
  var status = _enums.statusCodes.find(function (status) {
    return status.description === statusDescription;
  });
  return status ? status.code : -1;
};
var checkStatusObject = exports.checkStatusObject = function checkStatusObject() {
  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _status$code = status.code,
    code = _status$code === void 0 ? 0 : _status$code;
  var validStatus = _enums.statusCodes.find(function (statusObj) {
    return statusObj.code === code;
  });
  return validStatus;
};
var getStatusCodes = exports.getStatusCodes = function getStatusCodes(code) {
  if (code != null && code >= 0 && code <= 4) {
    return _enums.statusCodes.filter(function (statusCode) {
      return Math.floor(statusCode.code / 100) === code;
    });
  }

  // return all
  return _enums.statusCodes;
};
var getStatusIndex = exports.getStatusIndex = function getStatusIndex() {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return Math.floor(code / 100);
};
var getReasonIndex = exports.getReasonIndex = function getReasonIndex() {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return code % 100;
};